module.exports = __webpack_public_path__ + "img/BLA-01-30.8b53bc1a.svg";